var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 10.8435L12 9.818L14.2473 8.79255L15.2727 6.54528L16.2982 8.79255L18.5455 9.818L16.2982 10.8435L15.2727 13.0907L14.2473 10.8435ZM3.27273 15.2726L4.29818 13.0253L6.54545 11.9998L4.29818 10.9744L3.27273 8.7271L2.24727 10.9744L0 11.9998L2.24727 13.0253L3.27273 15.2726ZM8.18182 9.818L9.37091 7.18891L12 5.99982L9.37091 4.81073L8.18182 2.18164L6.99273 4.81073L4.36364 5.99982L6.99273 7.18891L8.18182 9.818ZM3.81818 22.3635L10.3636 15.8071L14.7273 20.1707L24 9.74164L22.4618 8.20346L14.7273 16.898L10.3636 12.5344L2.18182 20.7271L3.81818 22.3635Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.765ac4ace705fb114c846b16235ee40a.svg";
export { ForwardRef as ReactComponent };